import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Alert, Container, Spinner } from 'react-bootstrap';
import useUser from '../hooks/useUser';
import { fetchWithAuth } from '../utils/apiHelpers';

const DeploymentRedirectPage = () => {
  const { deployId } = useParams();
  const navigate = useNavigate();
  const { getApiToken, isLoading } = useUser();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!deployId || isLoading) return;

    let cancelled = false;

    const resolveDeployment = async () => {
      try {
        const token = await getApiToken();
        const status = await fetchWithAuth(token, `/deploy/${encodeURIComponent(deployId)}/status`);
        if (cancelled) return;

        if (status?.botId) {
          navigate(`/bot/${encodeURIComponent(status.botId)}?deployment=${encodeURIComponent(deployId)}`, {
            replace: true,
          });
          return;
        }

        setError('This deployment is not linked to a bot.');
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Could not open this deployment.');
        }
      }
    };

    resolveDeployment();
    return () => {
      cancelled = true;
    };
  }, [deployId, getApiToken, isLoading, navigate]);

  return (
    <Container className="py-5 text-light">
      {!error ? (
        <div className="d-flex flex-column align-items-center gap-3">
          <Spinner animation="border" variant="light" />
          <p>Opening bot...</p>
        </div>
      ) : (
        <Alert variant="danger">
          <div className="mb-2">{error}</div>
          <Link to="/my-bots">Go to My Bots</Link>
        </Alert>
      )}
    </Container>
  );
};

export default DeploymentRedirectPage;
